import React, { useEffect, useState, useRef } from 'react';
import {
  PopupWindow,
  Button,
  ValidationStyle,
  InputList,
  validationEngineFromInputInformationList,
} from '@utahdts/dts-react-common';
import PropTypes from 'prop-types';
import useRefLazy from '../../misc/hooks/useRefLazy';
import listingInputs from '../inputs/listingInputs';

const propTypes = {
  drug: PropTypes.object.isRequired,

  isNew: PropTypes.bool.isRequired,

  onClose: PropTypes.func.isRequired,

  onSave: PropTypes.func.isRequired,

  error: PropTypes.string,
};

const Listing = ({ drug, isNew, onClose, onSave, error }) => {
  const [isBusy, setBusy] = useState(false);

  const [inputValues, setInputValues] = useState(() => {
    const values = Object.assign(
      {
        id: null,
        org: null,
        ndc: null,
        description: null,
        type: '',
      },
      drug,
    );
    // Default to Generic when the drug has no type assigned; normalize case so
    // stored values like "Generic" match the select option values.
    values.type = values.type ? String(values.type).toLowerCase() : 'generic';
    return values;
  });
  const inputValuesRef = useRef();
  inputValuesRef.current = inputValues;

  const [validationEngineStyle, setValidationEngineStyle] = useState(
    ValidationStyle.BLURRED,
  );
  const validationEngineRef = useRef(undefined);

  const inputs = useRefLazy(() =>
    listingInputs(
      {
        inputsOnChange: (field, value) =>
          setInputValues((oldValues) => ({ ...oldValues, [field]: value })),
      },
      isNew,
    ),
  );

  const [validationEngine, setValidationEngine] = useState(undefined);
  validationEngineRef.current = validationEngine;
  if (validationEngine) {
    validationEngine.validationStyle = validationEngineStyle;
  }

  const submit = () => {
    setValidationEngineStyle(ValidationStyle.ALWAYS);
    if (
      validationEngineRef.current &&
      validationEngineRef.current.isValid(inputValuesRef.current)
    ) {
      setBusy(true);
      while (inputValues.ndc.length < 11) {
        inputValues.ndc = '0' + inputValues.ndc;
      }
      onSave(inputValues).catch(() => setBusy(false));
    }
  };

  useEffect(() => {
    setValidationEngine(
      validationEngineFromInputInformationList(inputs.current),
    );
  }, [inputs.current]);

  return (
    <PopupWindow
      className="popup-window--large"
      onCloseButtonCallback={onClose}
      footerChildren={[
        <Button
          label="Close"
          onClick={onClose}
          key="close-button"
          className="button--black"
        />,
        <Button
          label="Save"
          busy={isBusy}
          onClick={submit}
          key="save-button"
        />,
      ]}
    >
      <h3>{inputValues.id ? 'Edit Drug' : 'Add New Drug'}</h3>
      <InputList
        inputs={Object.values(inputs.current)}
        data={inputValues}
        validationEngine={validationEngine}
        className="stack-form flex flex-wrap half-form"
      />
      {error && <div className="form-error">{error}</div>}
    </PopupWindow>
  );
};

Listing.propTypes = propTypes;

export default Listing;
